import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation disableQuickbooksIntegrationMutation($input: DisableQuickbooksIntegrationInput!) {
		disableQuickbooksIntegration(input: $input) {
			company {
				quickbooksEnabled
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), realmId: input.realmId}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
